class HeaderMenu {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {		
    var windowWidth = $(window).width();
    var windowSm = 768;
		if (windowWidth <= windowSm) {
			$('.js-h-content a').on('click', function() {
				$('html').removeClass('is-open');
				scrollBan();
			});
		
			$('.js-mega-trigger').on('click', function(e) {
				// メガメニューのアコーディオン制御は「トリガー領域」のみで行い、
				// 配下のリンクタップは遷移を優先する
				if ($(e.target).closest('a').length) {
					return;
				}
				e.preventDefault();
			
				$(this).toggleClass('is-active');
				$(this).find('.js-mega-trigger-plus').toggleClass('is-active');
				$(this).find('.js-mega-content').slideToggle();
			});
		
		} else {
			// トリガー〜パネル間のわずかな隙間で閉じないよう、leave時に短い遅延を入れる
			let megaCloseTimer = null;

			$('.js-mega-trigger').on('mouseenter', function() {
				clearTimeout(megaCloseTimer);
				const $trigger = $(this);
				$('.js-mega-trigger').not($trigger).removeClass('is-active')
					.find('.js-mega-content, .js-mega-trigger-plus').removeClass('is-active');
				$trigger.addClass('is-active');
				$trigger.find('.js-mega-content').addClass('is-active');
				$trigger.find('.js-mega-trigger-plus').addClass('is-active');
			}).on('mouseleave', function() {
				const $trigger = $(this);
				megaCloseTimer = setTimeout(function() {
					$trigger.removeClass('is-active');
					$trigger.find('.js-mega-content').removeClass('is-active');
					$trigger.find('.js-mega-trigger-plus').removeClass('is-active');
				}, 200);
			});
		}
    
    $(window).scroll(function () {
      if ($(window).scrollTop() > 20) {
        $('html').addClass('is-scroll');
      } else {
        if (!$('html').hasClass('is-open')) {
          $('html').removeClass('is-scroll');
        }
      }
    });
    
    $('.js-drawer').click(function () {
      $('html').toggleClass('is-open');
      scrollBan();
    });

    // スマホメニュー内のクリック
    $('.js-header').find('a').click(function () {
      $('html').removeClass('is-open');
      scrollBan(false);
    });

    let scrollTop = 0;

    // html固定スクロール禁止/解除（引数なし=toggle / true=lock / false=unlock）
    const scrollBan = (() => {
      const html = document.documentElement; // $('html')[0] と同じ
      let locked = false;
      let scrollTop = 0;

      const lock = () => {
        if (locked) return;
        locked = true;

        scrollTop = window.scrollY || 0;

        // 現在位置を固定
        html.style.top = `${-scrollTop}px`;
        html.classList.add("is-hidden");
      };

      const unlock = () => {
        if (!locked && !html.classList.contains("is-hidden")) return;
        locked = false;

        // scroll-behavior を一時的に auto にして瞬間復帰
        const prevScrollBehavior = html.style.scrollBehavior;
        html.style.scrollBehavior = "auto";

        html.style.top = "";
        html.classList.remove("is-hidden");

        window.scrollTo(0, scrollTop);

        // 次フレームで元に戻す（0ms setTimeout より安全）
        requestAnimationFrame(() => {
          html.style.scrollBehavior = prevScrollBehavior;
        });
      };

      // state: true=lock / false=unlock / undefined=toggle
      return (state) => {
        if (typeof state === "boolean") {
          state ? lock() : unlock();
          return locked;
        }
        locked ? unlock() : lock();
        return locked;
      };
    })();
  }
}